// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor {
    overflow-wrap: break-word;
    font-family: steppe, sans-serif; }
  .editor h1,
  .editor h2,
  .editor h3 {
    font-family: steppe, sans-serif;
    font-size: 1.875rem;
    line-height: 2.25rem;
    --tw-text-opacity: 1;
    color: rgb(0 0 0 / var(--tw-text-opacity, 1)); }
  .editor h1 {
    font-size: 1.875rem;
    line-height: 2.25rem; }
  .editor h2 {
    font-size: 1.5rem;
    line-height: 2rem; }
  .editor h3 {
    font-size: 1.25rem;
    line-height: 1.75rem; }
  .editor ul {
    margin-left: 1.75rem;
    display: block;
    list-style-type: disc;
    color: inherit; }
  .editor ol {
    margin-left: 1.75rem;
    display: block;
    list-style-type: decimal;
    color: inherit; }
  .editor mark {
    border-radius: 0.125rem;
    padding: 0.125rem; }
  .editor a {
    --tw-text-opacity: 1;
    color: rgb(77 36 129 / var(--tw-text-opacity, 1));
    text-decoration-line: underline;
    text-underline-offset: 2px; }
  .editor p.is-editor-empty:first-child::before {
    pointer-events: none;
    float: left;
    height: 0px;
    color: rgb(94 94 94 / 0.5);
    content: attr(data-placeholder); }
  .editor p:empty::before {
    content: "";
    display: inline-block; }
`, "",{"version":3,"sources":["webpack://./src/components/TextEditor/styles.scss"],"names":[],"mappings":"AACE;IAAA,yBAAM;IAAN,iCAAM;EAKJ;;;IAAA,+BAAM;IAAN,mBAAM;IAAN,oBAAM;IAAN,oBAAM;IAAN,+CAAM;EAGN;IAAA,mBAAM;IAAN,sBAAM;EAGN;IAAA,iBAAM;IAAN,mBAAM;EAGN;IAAA,kBAAM;IAAN,sBAAM;EAIN;IAAA,oBAAM;IAAN,cAAM;IAAN,qBAAM;IAAN,gBAAM;EAGN;IAAA,oBAAM;IAAN,cAAM;IAAN,wBAAM;IAAN,gBAAM;EAIN;IAAA,uBAAM;IAAN,mBAAM;EAGN;IAAA,oBAAM;IAAN,iDAAM;IAAN,+BAAM;IAAN,4BAAM;EAKN;IAAA,oBAAM;IAAN,WAAM;IAAN,WAAM;IAAN,0BAAM;IACN,iCADM;EAlCV;IAwCI,WAAW;IACX,qBAAM,EAAA","sourcesContent":[".editor {\n  @apply font-steppe break-words;\n\n  h1,\n  h2,\n  h3 {\n    @apply text-3xl font-steppe text-black-base;\n  }\n  h1 {\n    @apply text-3xl;\n  }\n  h2 {\n    @apply text-2xl;\n  }\n  h3 {\n    @apply text-xl;\n  }\n\n  ul {\n    @apply block ml-7 text-inherit list-disc;\n  }\n  ol {\n    @apply block ml-7 text-inherit list-decimal;\n  }\n\n  mark {\n    @apply p-0.5 rounded-sm;\n  }\n  a {\n    @apply underline underline-offset-2 text-purple-base;\n  }\n\n  //for placeholder\n  p.is-editor-empty:first-child::before {\n    @apply text-gray-base/50 float-left h-0 pointer-events-none;\n    content: attr(data-placeholder);\n  }\n\n  // for hardbreak\n  p:empty::before {\n    content: \"\";\n    @apply inline-block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
